export default {
      id: "icon-xitter-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "dist/sprite.svg#icon-xitter",
      toString: function () {
        return this.url;
      }
    }